import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../../components/textbox/Input";
import styles from "../SchedaSpecialeArbovirosi.module.css";
import Utils from "../../../../../../../utils/Utils";

class ViaDiTrasmissione extends Component {
    state = {
        ViaDiTrasmissione: {
            viaTrasmissione: "",
            altroDettaglio: "",
            corretto: []
        }
    };

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.aggiornaPadre = this.aggiornaPadre.bind(this);
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
    }

    componentDidMount() {
        if (
            this.props.segnalazioneCopia &&
            this.props.segnalazioneCopia.schedaSpeciale &&
            this.props.segnalazioneCopia.schedaSpeciale.viaDiTrasmissione
        ) {
            this.setState(
                {
                    ViaDiTrasmissione: {
                        ...this.state.ViaDiTrasmissione,
                        ...this.props.segnalazioneCopia.schedaSpeciale.viaDiTrasmissione
                    }
                },
                () => this.aggiornaPadre()
            );
        } else if (this.props.segnalazioneCopia.datiSpecifici?.trasmissione) {
            this.setState(
                {
                    ViaDiTrasmissione: {
                        viaTrasmissione: this.props.segnalazioneCopia.datiSpecifici.trasmissione?.trasmissione? this.props.segnalazioneCopia.datiSpecifici.trasmissione.trasmissione === "216"? "VETTORE" :
                            this.props.segnalazioneCopia.datiSpecifici.trasmissione.trasmissione === "79"? "TRASFUSIONE_TRAPIANTO" :
                                this.props.segnalazioneCopia.datiSpecifici.trasmissione.trasmissione === "80"? "TRASFUSIONE_TRAPIANTO" :
                                    this.props.segnalazioneCopia.datiSpecifici.trasmissione.trasmissione === "76"? "SESSUALE" : "ALTRO" : "",
                        altroDettaglio: this.props.segnalazioneCopia.datiSpecifici.trasmissione?.trasmissione? this.props.segnalazioneCopia.datiSpecifici.trasmissione.trasmissione === "82" || this.props.segnalazioneCopia.datiSpecifici.trasmissione.trasmissione === "82*"? "NON NOTA" :
                            this.props.segnalazioneCopia.datiSpecifici.trasmissione.trasmissione === "81"? "LABORATORIO O OCCUPAZIONE" :
                                this.props.segnalazioneCopia.datiSpecifici.trasmissione.trasmissione === "77"? "MADRE - FIGLIO" : "" : ""
                    }
                },
                () => this.aggiornaPadre()
            );
        } else {
            this.aggiornaPadre();
        }
    }

    riceviValore(arg1, arg2) {
        let viaDiTrasmissione = this.state.ViaDiTrasmissione;
        let field, valore;

        // stessa logica robusta dell'altra classe
        if (typeof arg1 === "string" && arg2 && arg2.target) {
            field = arg1;
            valore = arg2.target.value;
        } else if (arg1 && arg1.target) {
            field = arg1.target.id || arg1.target.name || arg1.target.getAttribute("field");
            valore = arg1.target.value;
        }

        if (field) {
            viaDiTrasmissione[field] = valore;

            // business rule: se non è ALTRO svuoto il dettaglio
            if (field === "viaTrasmissione" && valore !== "ALTRO") {
                viaDiTrasmissione.altroDettaglio = "";
            }

            this.setState({ ViaDiTrasmissione: viaDiTrasmissione }, () => {
                this.aggiornaPadre();
            });
        }
    }

    aggiornaPadre() {
        this.controlloCorrettezza();
        if (this.props.controlloCorrettezza) this.props.controlloCorrettezza();

        let oggettoBE = this.createOggettoBE();

        if (this.props.setViaDiTrasmissione) {
            this.props.setViaDiTrasmissione(
                this.state.ViaDiTrasmissione,
                oggettoBE
            );
        }
    }

    controlloCorrettezza() {
        let dati = this.state.ViaDiTrasmissione;
        dati.corretto = [];

        if (dati.viaTrasmissione === "ALTRO" && !dati.altroDettaglio) {
            dati.corretto[1] = "Specificare il dettaglio per Altro";
        }
    }

    createOggettoBE() {
        let copiaDati = JSON.parse(JSON.stringify(this.state.ViaDiTrasmissione));
        let pulito = Utils.removeEmptyValueFromObject(copiaDati);
        return Utils.removeFieldFromObject(pulito, "corretto");
    }

    render() {
        const { t } = this.props;
        const { ViaDiTrasmissione: data } = this.state;
        const path = "SchedaSpecialeArbovirosi.ViaTrasmissione";

        const opzioni = [
            { id: "vettore", label: t(`${path}.vettore`), value: "VETTORE" },
            { id: "sessuale", label: t(`${path}.sessuale`), value: "SESSUALE" },
            { id: "trasfusione", label: t(`${path}.trasfusione`), value: "TRASFUSIONE_TRAPIANTO" },
            { id: "alimentare", label: t(`${path}.alimentare`), value: "ALIMENTARE" },
            { id: "prodotti", label: t(`${path}.prodotti`), value: "PRODOTTI_NON_PASTORIZZATI" },
            { id: "altro", label: t(`${path}.altro`), value: "ALTRO" }
        ];

        return (
            <div className={"container"}>
                <div style={{marginTop: "10px"}}/>
                <div className="row">
                    <div className="col-lg-4">
                        <p
                            style={{
                                fontWeight: "bold",
                                fontSize: "15px",
                                color: "black"
                            }}
                        >
                            {t(`${path}.titolo`)}
                        </p>
                    </div>

                    <div className="col-lg-7">
                        {opzioni.map((op) => (
                            <div key={op.id} className="row mb-2">
                                <div className="col-12 d-flex align-items-center"  style={{marginTop: "-12px", marginLeft: "50px"}}>
                                    <RadioButton
                                        id={op.id}
                                        name="viaTrasmissione"
                                        label={op.label}
                                        value={op.value}
                                        checked={data.viaTrasmissione === op.value}
                                        newRadio={true}
                                        onClick={this.riceviValore}
                                    />

                                    {op.value === "ALTRO" && (
                                        <div
                                            style={{
                                                marginLeft: "15px",
                                                flexGrow: 1,
                                                maxWidth: "400px"
                                            }}
                                        >
                                        <Input
                                            id="altroDettaglio"
                                            field="altroDettaglio"
                                            value={data.altroDettaglio}
                                            onChange={this.riceviValore}
                                            placeholder={t(`${path}.placeholderAltro`)}
                                            disabled={data.viaTrasmissione !== "ALTRO"}   
                                            />                          
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation("common")(ViaDiTrasmissione);